import { type UseMutationOptions, useMutation } from '@tanstack/vue-query'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import { HR_AUTH_LOGOUT } from '@/modules/Auth/requests/authEndpoints'
import type { LogoutPayload } from '@/modules/Auth/types/api'

export function logoutRequest(payload: LogoutPayload): Promise<void> {
  return axiosInstance
    .post(HR_AUTH_LOGOUT, payload, { skipErrorToast: true })
    .then(() => undefined)
}

export function useLogoutMutation(
  options?: UseMutationOptions<void, AxiosCustomError, LogoutPayload, unknown>
) {
  return useMutation({
    mutationFn: logoutRequest,
    ...options,
  })
}
